import { PROFILE_TYPES } from '@/utils/enums';

const state = () => ({
    show: false,
});

const mutations = {
    SHOW_MODAL(state) {
        state.show = true;
    },
    HIDE_MODAL(state) {
        state.show = false;
    },
};

const actions = {
    checkAndShowModal({ commit, rootGetters }) {
        const dismissed = localStorage.getItem('feature-modal-dismissed');

        if (dismissed) return;

        const userProfiles = rootGetters['profile/userRolesStatus'];

        const hasDeveloperProfile = userProfiles.some((profile) => profile.profile === PROFILE_TYPES.DEVELOPER);

        if (!hasDeveloperProfile) return;

        setTimeout(() => {
            commit('SHOW_MODAL');
        }, 3000);
    },
    hideModal({ commit }) {
        commit('HIDE_MODAL');
        localStorage.setItem('feature-modal-dismissed', 'true');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
